import { render, staticRenderFns } from "./Atender.vue?vue&type=template&id=aae0269a&scoped=true&"
import script from "./Atender.vue?vue&type=script&lang=js&"
export * from "./Atender.vue?vue&type=script&lang=js&"
import style0 from "./Atender.vue?vue&type=style&index=0&id=aae0269a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae0269a",
  null
  
)

export default component.exports